import { ApiPortfolio } from '../models/ApiPortfolio';
import AuthService from '../../shared/services/AuthService';
import { AxiosError } from 'axios';
import Config from '../../shared/config';
import useSWRMutation from 'swr/mutation';

export interface PortfolioArgType {
  modulekey: number;
  userkey: number;
}
const useUserModulePortfolio = () => {
  const portfolioUrl = `${Config.API}/api/portfolio/list/portfolio/user`;

  const headers = {
    Authorization: `Bearer ${AuthService.getAccessToken()}`,
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };

  const fetcher = async (url: string, { arg }: { arg: PortfolioArgType }) => {
    const portfolioUrl =
      arg.modulekey && arg.userkey
        ? `${url}/${arg.userkey}/module/${arg.modulekey}`
        : null;

    return fetch(portfolioUrl, {
      headers,
      method: 'GET'
    }).then(async (res) => await res.json());
  };

  const {
    trigger: loadPortfolios,
    isMutating: loadingPortfolios,
    data: portfoliosData,
    error: loadPortfolioError
  } = useSWRMutation<ApiPortfolio[], AxiosError<Error>, any, PortfolioArgType>(
    portfolioUrl,
    fetcher
  );

  return {
    loadPortfolios,
    loadingPortfolios,
    loadPortfolioError
  };
};

export default useUserModulePortfolio;
